export default __webpack_public_path__ + "static/media/group.b28dfe0c.svg";